<template>
  <section-page
    title="Team"
    full-height
  >
    <template v-slot:right>
      <table-buttons
        show-refresh
        show-filters-button
        :do-refresh="refresh"
        :do-filters-apply="applyFilters"
        :do-filters-reset="resetFilters"
      >
        <template v-slot:columns></template>

        <template v-slot:filters>
          <stats-team-filter ref="teamFilter"/>
        </template>
      </table-buttons>
    </template>

    <b-tabs v-model="activeTab" type="is-boxed">
      <b-tab-item
        v-for="(tab, index) in tabs"
        :key="index"
        :value="tab.component"
        :label="tab.label"
      >
        <component v-bind:is="tab.component" ref="tabComponent"></component>
      </b-tab-item>
    </b-tabs>
  </section-page>
</template>

<script>
import StatsTeamUsers from "./components/StatsTeamUsers.vue";
import StatsTeamComms from "./components/StatsTeamComms.vue";
import StatsTeamTasks from "./components/StatsTeamTasks.vue";
import StatsTeamLeadIntake from "./components/StatsTeamLeadIntake.vue";
import StatsTeamAcquisitions from "./components/StatsTeamAcquisitions.vue";
import StatsTeamFilter from "./components/StatsTeamFilter.vue";
import TableButtons from "../../components/table/TableButtons.vue";
import StatsKpiFilter from "./components/StatsKpiFilter.vue";
import CancelablePromise from "../../services/CancelablePromise";

export default {
  name: "StatsTeamTab",
  components: {
    TableButtons,
    StatsKpiFilter,
    StatsTeamFilter,
    // StatsTeamUsers,
    StatsTeamTasks,
    StatsTeamComms,
    StatsTeamLeadIntake,
    StatsTeamAcquisitions,
  },
  data() {
    return {
      reloadingPromise: null,
      tabs: [
        // { label: 'Users', component: 'StatsTeamUsers' },
        { label: 'Tasks', component: 'StatsTeamTasks' },
        { label: 'Comms', component: 'StatsTeamComms' },
        { label: 'Lead Intake', component: 'StatsTeamLeadIntake' },
        { label: 'Acquisitions', component: 'StatsTeamAcquisitions' },
      ],
    }
  },
  destroyed() {
    this.$store.commit('statsTeam/setActiveTab', null)
  },
  mounted() {
    this.$store.commit('statsTeam/setActiveTab', 'StatsTeamTasks')
  },
  computed: {
    activeTab: {
      get() {
        return this.$store.getters['statsTeam/getActiveTab']
      },
      set(value) {
        this.$store.commit('statsTeam/setActiveTab', value)
      }
    }
  },
  methods: {
    applyFilters() {
      this.$refs.teamFilter.applyFilter()
      this.refresh()
    },
    resetFilters() {
      this.$refs.teamFilter.resetFilter()
    },
    async refresh() {
      const tabIndex = this.tabs.findIndex(tab => tab.component === this.activeTab)

      if (this.reloadingPromise) {
        this.reloadingPromise.cancel();
      }

      this.reloadingPromise = CancelablePromise(new Promise(async (resolve) => {
        await this.$refs.tabComponent[tabIndex].loadStats();
        resolve();
      }))
    },
  },
}
</script>

<style scoped lang="scss">
.tab-loading-section {
  min-height: 150px;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
</style>
